import loadable from '@loadable/component';

// Lazy-loaded: react-google-recaptcha requires browser environment
export const RecaptchaField = loadable(
  () => import(/* webpackChunkName: "RecaptchaField" */ './RecaptchaField'),
  { ssr: false }
);

export { default as translations } from './translations.json';
